import { render, staticRenderFns } from "./OperacionalIcon.vue?vue&type=template&id=12ef7778&"
import script from "./OperacionalIcon.vue?vue&type=script&lang=ts&"
export * from "./OperacionalIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports